import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type ShipmentCategoryEntity } from '@/libs/api'

import { ShipmentCategoryCreateModalContent } from './ShipmentCategoryCreateModalContent'

type Props = {
  open: boolean
  tenantKey: string
  onSuccess: (shipmentCategories: ShipmentCategoryEntity) => Promise<void>
  onClose: () => void
}

export const ShipmentCategoryCreateModal: FC<Props> = ({
  open,
  tenantKey,
  onSuccess,
  onClose
}) => {
  return (
    <Modal
      title={MENU.CREATING_SHIPMENT_CATEGORY}
      zIndex={1999}
      width={860}
      open={open}
      onCancel={onClose}
    >
      <ShipmentCategoryCreateModalContent
        tenantKey={tenantKey}
        onSuccess={onSuccess}
        onCancel={onClose}
      />
    </Modal>
  )
}
